<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div style="float: right">
          <OfSearch
            @search="search"
            style="float: left; padding-right: 5%"
            :placeholder="placeholder"
          ></OfSearch>
          <el-button type="danger" @click="btnSearch">查询</el-button>
        </div>
      </div>
      <div>
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabsClick"
        >
          <el-tab-pane label="个人" name="personal">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :data="personalModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Name"
                label="姓名"
                width="100"
                align="center"
                fixed
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="Sex"
                label="性别"
                width="60"
                align="center"
                :formatter="Sex"
              />
              <el-table-column
                prop="IdentityCard"
                label="身份证号码"
                width="165"
                align="center"
              />
              <el-table-column
                prop="Email"
                label="电子邮箱"
                width="180"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Address"
                label="联系地址"
                align="left"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="IsVolunteer"
                label="是否愿意成为红十字救护志愿者"
                width="130"
                align="center"
                :formatter="IsVolunteer"
              />
              <el-table-column
                prop="Phone"
                label="手机号码"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Amount"
                label="报名费用"
                width="100"
                align="center"
              />
              <el-table-column
                fixed="right"
                label="操作"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    type="text"
                    size="mini"
                    @click="read(scope.row)"
                    >详情</el-button
                  >
                  <el-button
                    v-access:read
                    type="text"
                    size="mini"
                    @click="downloadIdPhotoFile(scope.row)"
                    >下载照片</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="团体" name="group">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :data="groupModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Name"
                label="企业名称"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="ContactUser"
                label="联系人"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="联系电话"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Amount"
                label="费用"
                width="90"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" width="15z0" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:read
                    type="text"
                    size="mini"
                    @click="downloadIdPhotoFile(scope.row)"
                    >下载照片</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <div class="pagination-wapper">
            <OfPagination
              :total="total"
              :pageSize="pageSize"
              :currentPage="currentPage"
              @onSizeChange="handleSizeChange"
              @onCurrentChange="handleCurrentChange"
            ></OfPagination>
          </div>
        </el-tabs>
        <ModuleDetail
          v-if="formVisible"
          :applyId="applyId"
          :formTitle="formTitle"
          @formCallBack="formCallBack"
        />
        <el-dialog
          class="lifeGuardQuery"
          title="救护员培训报名"
          :visible.sync="dialogVisible"
          width="65%"
          :before-close="handleClose"
        >
          <div class="lifeGuard-content">
            <el-row class="item-row">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">姓名：</el-col>
                  <el-col :span="16">{{ trainApply.Name }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">性别：</el-col>
                  <el-col :span="16">{{
                    trainApply.Sex === 0 ? "女" : "男"
                  }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="12" class="item-col-left"
                    >是否成为志愿者：</el-col
                  >
                  <el-col :span="12">{{
                    trainApply.IsVolunteer ? "是" : "否"
                  }}</el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item-row">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">手机号码：</el-col>
                  <el-col :span="16">{{ trainApply.Phone }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">证件号码：</el-col>
                  <el-col :span="16">{{ trainApply.IdentityCard }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="12" class="item-col-left">身份证类型：</el-col>
                  <el-col :span="12">{{
                    trainApply.IdType === 1 ? "其他" : "身份证"
                  }}</el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item-row">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">电子邮箱：</el-col>
                  <el-col :span="16">{{ trainApply.Email }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">出生日期：</el-col>
                  <el-col :span="16">{{
                    (trainApply.Birthday * 1000) | formatDate2
                  }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="12" class="item-col-left">民族：</el-col>
                  <el-col :span="12">{{ trainApply.National }}</el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item-row">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">职业：</el-col>
                  <el-col :span="16">{{
                    showProfessional(trainApply.Professional)
                  }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">工作单位：</el-col>
                  <el-col :span="16">{{ trainApply.WordUnit }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="12" class="item-col-left">文化程度：</el-col>
                  <el-col :span="12">{{
                    showEducation(trainApply.Education)
                  }}</el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item-row">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" class="item-col-left">身份属性：</el-col>
                  <el-col :span="16">{{
                    showIdentity(trainApply.IdentityAttr)
                  }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="16">
                <el-row>
                  <el-col :span="4" class="item-col-left">地址：</el-col>
                  <el-col :span="20">{{
                    trainApply.CityName || "" + trainApply.Address
                  }}</el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item-row">
              <el-col :span="16">
                <el-row>
                  <el-col :span="4" class="item-col-left">证件照：</el-col>
                  <el-col :span="20">
                    <el-row>
                      <el-col :span="20">{{ IdPhotoFile.name }}</el-col>
                      <el-col :span="4"
                        ><el-button
                          type="text"
                          style="padding: 0"
                          @click="readImage"
                          >查看</el-button
                        ></el-col
                      >
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="18"></el-col>
            </el-row>
          </div>
        </el-dialog>
      </div>
      <imageViewer
        v-if="isShowImageViewe"
        :imageViewerUrl="imageViewerUrl"
        @closeImageViewer="closeImageViewer"
      />
    </BasePage>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModuleDetail from "@/modules/zjrc/pages/train/trainapply/detail_personaltrain";
import api from "@/modules/zjrc/api";
import { formatData } from "@/utils/index";
import imageViewer from "@/components/controls/of_imageViewer";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isloading: false,
      width: "80%",
      personalModel: [],
      groupModel: [],
      activeName: "personal",
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchKey: "",
      type: 1,
      formData: {},
      formVisible: false,
      applyId: "",
      id: "",
      placeholder: "请输入姓名",
      dialogVisible: false,
      trainApply: {},
      IdPhotoFile: {},
      imageViewerUrl: "",
      isShowImageViewe: false,
    };
  },
  mounted() {
    this.id = this.$route.query.Id;
    this.loadData();
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleDetail,
    imageViewer,
  },
  methods: {
    downloadIdPhotoFile(row) {
      const vm = this;
      if(row.IdPhotoFile && row.IdPhotoFile !== null && row.IdPhotoFile !== ''){
        vm.getFile(row.IdPhotoFile).then(res=>{
          saveAs(res.url, res.name);
        })
      }
    },
    closeImageViewer() {
      const vm = this;
      vm.isShowImageViewe = false;
    },
    readImage() {
      const vm = this;
      vm.imageViewerUrl = vm.IdPhotoFile.url;
      vm.isShowImageViewe = true;
    },
    getFile(fileId) {
      const vm = this
      return new Promise((resolve, reject)=>{
        const params = { Id: fileId };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code === 0) {
            vm.IdPhotoFile = {
              url: "/files" + res.data.Data[0].StorePath,
              name: res.data.Data[0].FileName,
            };
            resolve(vm.IdPhotoFile)
          }else{
            reject()
          }
        });
      })
    },
    showProfessional(value) {
      if (value !== null) {
        return formatData(value, this.professional);
      } else {
        return "-";
      }
    },
    showIdentity(value) {
      if (value && value !== null) {
        return formatData(value, this.identityAttr);
      } else {
        return "-";
      }
    },
    showEducation(value) {
      if (value && value !== null) {
        return formatData(value, this.education);
      } else {
        return "-";
      }
    },
    read(row) {
      const vm = this;
      vm.trainApply = row;
      if(row.IdPhotoFile && row.IdPhotoFile !== null && row.IdPhotoFile !== ''){
        vm.getFile(row.IdPhotoFile).then(()=>{
          vm.dialogVisible = true;
        });
      }
    },
    handleClose() {
      const vm = this;
      vm.dialogVisible = false;
    },
    cancel() {
      this.$emit("formCallBack", null);
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        TrainId: this.id,
        MemberType: this.type,
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        SearchKey: this.searchKey,
      };
      api
        .QueryLifeGuardDetail(params)
        .then((rep) => {
          if (rep.data.Code === 0) {
            this.total = rep.data.Data.total;
            if (this.type == 1) {
              this.personalModel = rep.data.Data.rows;
            } else {
              this.groupModel = rep.data.Data.rows;
            }
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
      this.isloading = false;
    },
    //是否愿意成为红十字救护自愿者
    IsVolunteer(rowData) {
      return rowData.IsVolunteer == 0 ? "否" : "是";
    },
    //性别
    Sex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    //tab切换
    handleTabsClick(tab, event) {
      if (tab.name == "personal") {
        this.type = 1;
        this.placeholder = "请输入姓名";
      } else {
        this.type = 2;
        this.placeholder = "请输入企业名称";
      }
      this.loadData();
    },
    //详情
    innerRead(rowData) {
      this.applyId = rowData.Id;
      this.formVisible = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      if (data != null) {
        this.loadData();
      }
    },
    //关键字查询
    search(searchKey) {
      let that = this;
      that.searchKey = searchKey;
    },
    //搜索
    btnSearch() {
      let that = this;
      that.currentPage = 1;
      that.loadData();
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-list__item-delete {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
/* table表头错位修正 */
.el-table th.gutter {
  display: table-cell !important;
}
</style>
<style lang="scss" scoped>
.gutter-th {
  &.el-table th.gutter {
    display: none;
    width: 0;
  }
  &.el-table colgroup col[name="gutter"] {
    display: none;
    width: 0;
  }
}
.lifeGuardQuery {
  .lifeGuard-content {
    .item-row {
      padding: 12px 0;
      border-bottom: 1px dashed rgb(201, 198, 198);
      .item-col-left {
        text-align: right;
        padding-right: 5px;
      }
    }
  }
}
</style>
